import {__} from "./__";

export const getAdditionalPlaceholders = () => {
    return {
        '{order.delivery_name}': __('Názov dodania'),
        '{order.payment_name}': __('Názov platby'),
        '{order.products_total}': __('Celková suma produktov'),
        '{order.delivery_type_amount}': __('Celková suma za dopravu'),
        '{order.payment_type_amount}': __('Celková suma za platbu'),
        '{order.public_url}': __('Track & Trace verejná stránka objednávky'),
        '{invoice.number}': __('Číslo faktúry'),
        '{package.number}': __('Číslo zásielky'),
    };
};
